import {useContext} from "react";
import {OrgDataContext, OrgDataProviderContext} from "context/orgData";
import * as constants from 'common/constants';

function isTalos(orgData: OrgDataProviderContext) {
    return constants.organization.isTalosCustomer(orgData.getOrgIDByType('customer'));
}

type GroupByOption = 'none' | 'contract';

export function useFlightsTableFeatureFlags() {

    const orgData = useContext(OrgDataContext);

    const flags = {
        preferredGroupBy: 'none' as GroupByOption
    }

    if (isTalos(orgData)) {
        // Hide customs printout feature for Talos only
        flags.preferredGroupBy = 'contract';
    }

    return flags;
}
